import { Loader2 } from 'lucide-react';

/**
 * Splash screen component displayed while user authentication is in progress
 */
export function SignInSplash() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-lg text-muted-foreground">Signing you in</p>
      </div>
    </div>
  );
}
